<template>

  <div>

    <div>

      <template>
        <div>
          <iframe style="width:100%;height:500px" src="http://192.168.20.2:8085/readfile/1.pdf" title="SoftlineAngola"></iframe>
        </div>
      </template>
      <div>
        <v-card-actions>
          <v-btn color="primary">Voltar</v-btn>
        </v-card-actions>

      </div>

    </div>
  </div>
</template>

<script>

import axios from '../../plugins/axios'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
export default {
  data: () => ({
    config: '',
    url: '',
    html: '',
    empresa: {
      'nome_empresa': 'Colégio Bendizer',
      'localidade': 'Vila-Alice',
      'zona': 'Rangel',
      'provincia': 'Luanda',
      'telefone': '999207671',
      'email': 'ColegioBendizer@gmail.co.ao',
      'detalhes': 'Matric. Conservatória do Registo Comercial de Luanda',
      'contribuente': '5480006576',
      'NIF': '2401268340'

    },
    turma: {
      descricao: ls.get('turma').descricao,
      classe: ls.get('turma').classe,
      curso: ls.get('turma').curso,
      anolectivo: ls.get('turma').anolectivo
    },
    devedores: [], // ls.get('estudantes_'),
    // devedores: [
    //   {
    //     'nome': 'Mário Carlos',
    //     'matricula': '665557',
    //     'mes': 'Janeiro,Fevereiro,Março,Abril',
    //     'divida': '20000'
    //   }
    // ],
    formatter: 0,
    date: null
  }),
  created () {
    this.getConfig()
  },

  methods: {

    async getConfig () {
      try {
        if (window.location.host.includes('localhost')) {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA' }
        } else if (window.location.host.includes('isppluena.com') || window.location.host.includes('192.168.20.2')) {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
        } else if (window.location.host.includes('ispatlantida.com') || window.location.host.includes('192.168.44.10')) {
          this.config = { logo: 'logoAt.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA' }
        } else if (window.location.host.includes('ispamazozo.com')) {
          this.config = { logo: 'logoMazozo.jpeg', descricao: 'INSTITUTO SUPERIOR PRIVADO-ATLÂNTIDA-MAZOZO' }
        } else {
          this.config = { logo: 'logo.jpeg', descricao: 'INSTITUTO  SUPERIOR POLITÉCNICO PRIVADO DO LUENA' }
        }
      } catch (error) {
      } finally {
        this.html_pdf()
      }
    },

    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
   
    /** Compondo o cabeçario contendo os meses  */
    mesesHeader (array) {
      let arrayMesesHeadeer = `  <tr>
  <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px;width:200px!important">Nome</th>
  <th bgcolor="#DCDCDC" style="text-align:justify;font-size:8px;padding-top:10px;padding-bottom:10px;">Matricula</th>
  `
      switch (array.length) {
        case 1:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[0] </th></tr>`
          break
        case 2:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px"> array[0]</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[1] </th>
        </tr>`
          break
        case 3:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px"> array[0]</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[1] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[2] </th>
        </tr>`
          break
        case 4:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px"> array[0]</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[1] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[2] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[3] </th>
        </tr>`
          break
        case 5:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px"> array[0]</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[1] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[2] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[3] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[4] </th>
        </tr>`
          break
        case 6:
          arrayMesesHeadeer += ` <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px"> array[0]</th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[1] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[2] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[3] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[4] </th>
        <th bgcolor="#DCDCDC" style="text-align:justify;padding-top:10px;padding-bottom:10px;font-size: 8px">array[5] </th>
        </tr>`
          break
        default:
          arrayMesesHeadeer += `</tr>`
      }
      return arrayMesesHeadeer
    },
    /** Compondo os items dos devedores */
    rowsDivida (arrayMesesHeadeer) {
      let dados = ``
      switch (arrayMesesHeadeer.length) {
        case 1:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        case 2:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        case 3:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        case 4:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        case 5:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        case 6:
          this.devedores.forEach(element => {
            dados += `<tr>
          <td valign="top" style="text-align:justify;font-size:8px;">` + element.nome + `</td>
           <td valign="top" style="text-align:justify;font-size:8px;" >` + element.numero_matricula + `</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          <td valign="top" style="text-align:left;margin-left:80px;font-size:6px;">[` + element.meses + `]</td>
          </tr>`
          })
          return dados
        default:
          return dados
      }
    },
    html_pdf () {
      this.devedores = [{ nome: 'trrrr', numero_matricula: '3444', meses: 'PAGO' }]
      let options = {
        'format': 'A4',
        'border': {
          // default is 0, units: mm, cm, in, px
          'right': '12mm',
          'left': '12mm'
        },
        'header': {
          'height': '15mm'
        },
        'footer': {
          'height': '12mm'

        }
      }

      this.html = `
       <html>
<head>
<style>
table, th, td {
  border: 0px solid black;
  border-collapse: collapse;
  font-size: 11px;
}
.linhas {
  border: 1px solid #808080;
}
#rcorners2 {
   border-radius: 25px;
  border: 1px solid #000000;
  padding: 25px; 
  padding-top: 2px;
  width: 250px;
  height: 40px;
}
.column {
  float: left;
  width: 70.33%;
  padding: 5px;
}
.footer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
}
</style>
</head>
<body>
  
 <table style="border:0px solid black;margin-left:0px;margin-right:auto;width:100%">
    <tr>
        <td>
            <div class="column">
    <span>  <img src="http://192.168.20.2:8085/readfile/` + this.config.logo + `" alt="Snow" style="width:50%; max-width:80px;" /></span>
  </div>
        </td>
         <td> 
          <strong style=" font-size:15px;">` + this.config.descricao + `</strong>
        </td>
         
    </tr>
       </table>
       <div style="text-align:center;padding:5px;"><strong style=" font-size:10px">  Lista de estudantes devedores da turma: </strong> </div>
          <div id="rcorners2">          
         <span style="font-size:10px">Curso: </span><br>
          <span style="font-size:10px">Ano académico: º </span> <br>
          <span style="font-size:10px">Semestre: º </span>
          <br><span style="font-size:10px">Ano Lectivo: </span><br>
          <span style="font-size:10px">Emitido em  ` + this.correntDate() + ` </span>         
        </div>
        <table style="width:100%;margin-top:10px">
        ` + this.mesesHeader([1, 2, 3, 4]) + `
        ` + this.rowsDivida([1, 2, 3, 4]) + `
          </table>
</body>
</html>`
      this.gerarPDF(options)
    },
    async gerarPDF (options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: 'http://192.168.20.2:8085/writefile',
          data: {
            html: this.html,
            file_name: 1, // ls.get('nomeUsuario'),
            option: options
          }
        }).then(function (response) {
          console.log('sucesso ')
        })
        // Imprimir PDF
        this.isLoading = false
        // this.url = 'https://ims.eftsk.com/readfile/' + ls.get('nomeUsuario') + '.pdf'
      } catch (error) {
        this.isLoading = false
      }
    },
    correntDate () {
      let data = new Date()
      var month = []
      month[0] = 'Janeiro'
      month[1] = 'Fevereiro'
      month[2] = 'Maço'
      month[3] = 'Abril'
      month[4] = 'Maio'
      month[5] = 'Junho'
      month[6] = 'Julho'
      month[7] = 'Agosto'
      month[8] = 'Setembro'
      month[9] = 'Outubro'
      month[10] = 'Novembro'
      month[11] = 'Dezembro'
      return data.getDate().toString() + ' de ' + month[(data.getMonth())] + ' de ' + data.getFullYear().toString() + ' ás ' + data.getHours() + ':' + data.getMinutes() + ':' + data.getSeconds()
    }
  }

}

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}

.progressCircularIsMatriculaURL {
  margin: 1rem;

  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;

}
</style>
